class Multicolumn1{
  constructor(section){
    this.sectionElement = document.querySelector(section);
    this.h3Element1 = this.sectionElement.querySelectorAll('.inline-richtext.multi-text em');
    this.mulSections = this.sectionElement.querySelectorAll('.multicolumn-card__info.multicolumn-card-info');
    this.init();
  }
  init = () => {
    if (this.mulSections.length > 0) this.mulSections[0].classList.add('align-top');
    if (this.mulSections.length > 1) this.mulSections[1].classList.add('align-top');
    
    this.h3Element1.forEach((element) => {
      if (element) {
            var spanElement = document.createElement('span');
            spanElement.textContent = element.textContent;
            element.parentNode.replaceChild(spanElement, element);
      }
    });
    const observer = new MutationObserver(this.changeColor);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', this.changeColor);
    this.changeColor();
  }
  changeColor = () => {
    let mulElements = this.sectionElement.querySelectorAll('.multi-text');
    let mulButtons = this.sectionElement.querySelectorAll('.multicolumn-card__info .top-left .link.button.animate-arrow');

    if (window.innerWidth <= 767) {
        if (mulElements.length > 3) {
            mulElements[3].style.color = 'white';
        }

        if (mulElements.length > 5) {
            mulElements[5].style.color = 'white';
        }

        if (mulButtons.length > 3) {
            mulButtons[3].style.color = 'white';
        }

        if (mulButtons.length > 5) {
            mulButtons[5].style.color = 'white';
        }
    } else {
        // Reset the color for desktop view
        if (mulElements.length > 3) {
            mulElements[3].style.color = 'initial';
        }

        if (mulElements.length > 5) {
            mulElements[5].style.color = 'initial';
        }
    }
  }
}